module.exports = __webpack_public_path__ + "img/delete-right.00e67d12.svg";